import styled from 'styled-components';

export const ContainerFooterMobile = styled.div`
  display: flex;
  flex-direction: column;
  flex: none;
  width: 100vw;
  height: 10.738vh;
  background-color: #000000;
  align-items: center;
  text-align: center;
  justify-content: center;
`;

export const ContainerTextAndIconFooter = styled.div`
  display: flex;
  font-family: 'Libre Franklin', sans-serif;
  font-size: 2.666vw;
  font-weight: 500;
  background-color: transparent;
  text-indent: 1.333vw;
  color: #ffffff;
  margin-bottom: 2vw;
  align-items: center;
  text-align: center;
`;

export const IconsFooter = styled.img<{
  marginMobile?: string;
  widthIcon: string;
  heightIcon: string;
}>`
  background-color: transparent;
  margin: ${(props) => props.marginMobile};
  width: ${(props) => props.widthIcon};
  height: ${(props) => props.heightIcon};
`;
